export const { VUE_APP_API_URL } = process.env;
